import { IppicaTicketActionScommetti } from 'features/ippica/components/ippicaTicket/components/ippicaTicketActionScommetti';
import { SportTicketActionScommetti } from 'features/sport/components/sportTicket/components/sportTicketActionScommetti';
import { VirtualTicketActionScommetti } from 'features/virtual/components/virtualTicket/components/virtualTicketActionScommetti/VirtualTicketActionScommetti';
import { useTypedSelector } from 'lib/centralStore';
import { selectTipo } from 'features/carrello/carrelloSelectors';
import { isCarrelloTypeIppica, isCarrelloTypeSport } from 'features/carrello/utils';

export type CarrelloActionScommettiProps = {
  btnClassName?: string;
};

export const CarrelloActionScommetti = ({ btnClassName }: CarrelloActionScommettiProps) => {
  const tipo = useTypedSelector(selectTipo);

  if (isCarrelloTypeSport(tipo)) {
    return <SportTicketActionScommetti btnClassName={btnClassName} />;
  } else if (isCarrelloTypeIppica(tipo)) {
    return <IppicaTicketActionScommetti btnClassName={btnClassName} />;
  } else {
    return <VirtualTicketActionScommetti btnClassName={btnClassName} />;
  }
};